import React from "react";
import Link from "next/link";
import type {UrlObject} from "url";
import {Locale} from "~/i18n-config";
import {localizePathname} from "~/utils/locales";
import clsx from "clsx";

export type LangLinkProps = {
    href: string | UrlObject;
    lang: Locale | string;
    children: React.ReactNode;
    [key: string]: any;
};

export const LangLink = React.forwardRef<HTMLAnchorElement, LangLinkProps>(
    ({ href, lang, children, className, ...props }, ref) => {
        return (
            <Link
                prefetch={false}
                href={localizePathname(lang, href)}
                ref={ref}
                className={clsx("outline-hidden transition-opacity focus-visible:opacity-75", className)}
                {...props}
            >
                {children}
            </Link>
        );
    });
